import { connect } from "react-redux";
import Component from "./LoginContainer";


export default connect(
      ({ auth: { callback } }) => ({ callback }),
      ({ auth: { login, forceChangePassword
      } }) => ({ login, forceChangePassword })
)(Component);
